import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import MenuItemLink from './MenuItemLink';

const MenuColumn = ({ column, lang, colClassName, labelClassName, iconClassName, linkClassName, onItemClick }) => {
  const { tempedgeTranslator } = useTempEdgeTranslator();

  return (
    <div className={colClassName}>
      <span className={labelClassName}>{tempedgeTranslator(column.key)}</span>
      <ul>
        {column.items.map((item) => (
          <MenuItemLink
            key={item.optionPath}
            item={item}
            lang={lang}
            iconClassName={iconClassName}
            linkClassName={linkClassName}
            onClick={onItemClick}
          />
        ))}
      </ul>
    </div>
  );
};

export default MenuColumn;
